import { ProductImageTag } from '../productdetail/types';
import { ProductInterface } from './types';

const generateProductPlaceHolders = (count: number): ProductInterface[] => {
    return new Array(count).fill({}).map((item, index) => ({
        sku: `sku-placeholder-${index}`,
        simpleSku: `simple-sku-placeholder-${index}`,
        baseImage: 'placeholder_image_url',
        name: '',
        altTag: '',
        brand: '',
        blackFriday: false,
        cyberMonday: false,
        isSustainable: false,
        price: '',
        originalPrice: '',
        link: '',
        simplesCount: 0,
        position: index,
        quantityBadge: 0,
        soldOut: false,
        productImage: {
            path: '',
            seoUrl: '',
            tag: ProductImageTag.REGULAR,
        },
    }));
};

export default generateProductPlaceHolders;
